import React from "react";
import { Divider, notification, Input, Button, Modal,Tag } from "antd";
import { Table } from "ant-table-extensions";
import { Link } from "react-router-dom";
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { MdNavigateNext, MdNavigateBefore } from "react-icons/md";
import { Row, Col } from 'react-bootstrap';
import { FaTrashAlt, FaRegEdit, FaTrashRestoreAlt } from 'react-icons/fa';
import Auxiliary from "util/auxiliary";
import PageHeader from "components/PageHeader";
import { ExclamationCircleOutlined } from '@ant-design/icons';

import {
  listEventImageType,
  deleteEventImageType,
  searchEventImageType,
  resetEventImageType
} from "./../../../appRedux/actions/eventImages";

const { Search } = Input;
const getRandomuserParams = params => ({
  results: params.pagination.pageSize,
  page: params.pagination.current,
  ...params,
});

const itemRender = (current, type, originalElement) => {
  if (type === 'prev') {
    return <Button className="ant-paginatio-button"><MdNavigateBefore className="icon-size" /> Previous</Button>;
  }
  if (type === 'next') {
    return <Button className="ant-paginatio-button">Next <MdNavigateNext className="icon-size" /></Button>;
  }
  return originalElement;
}

class ListEventImageType extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentInstance: this,
      record: null,
      eventImageTypeList: [],
      pagination: {
        current: 1,
        pageSize: 10
      }
    }

    this.columns = [{
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      sorter: (a, b) => a.name.length - b.name.length,
      sortDirections: ['descend', 'ascend']
    }, {
      title: 'Description',
      dataIndex: 'description',
      key: 'description'
      }, {
        title: 'Status',
        dataIndex: 'isDeleted',
        key: 'isDeleted',
        sorter: (a, b) => a.isDeleted - b.isDeleted,
        sortDirections: ['descend', 'ascend'],
        render: (isDeleted) => {
          return (<Tag color={isDeleted ? "warning" : 'processing'}>
            {isDeleted ? 'Deleted' : 'Active'}
          </Tag>)
        },
        filters: [
          {
            text: 'Active',
            value: false
          },
          {
            text: 'Deleted',
            value: true
          }
        ],
        filterMultiple: false,
        onFilter: (value, record) => record.isDeleted === value
      }, {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      sortDirections: ['descend', 'ascend'],
      render: (createdAt) => { return (<span>{moment(createdAt).format('MM-DD-YYYY hh:mm a')}</span>) }
    }, {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      sortDirections: ['descend', 'ascend'],
      render: (updatedAt) => { return (<span>{moment(updatedAt).format('MM-DD-YYYY hh:mm a')}</span>) }
    }, {
      title: 'Action',
      key: 'action',
      width: 150,
      render: (text, record) => (
        <span>
          <span className="gx-link">           
            { <Link to={`/event-image/edit/${record._id}`}><FaRegEdit className="icon-size gx-link" /></Link>}
          </span>
          <Divider type="vertical" />
          {!record.isDeleted ?
            <span title="Delete" className="gx-link delete-color" onClick={(e) => { this.onConfirmDelete(record); }}>
              <FaTrashAlt className="icon-size" />
            </span>
            :
            <span title="Restore" className="gx-link delete-color" onClick={(e) => { this.onConfirmRestore(record); }}>
              <FaTrashRestoreAlt className="icon-size" />
            </span>
          }
        </span>
      ),
    }]

  };

  componentDidMount() {
    const { pagination } = this.state;
    this.fetch({ pagination });
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.eventImage) {
      if (nextProps.eventImage.messageId === 204) {
        return {
          eventImageTypeList: nextProps.eventImage.event_image_types.data,
          pagination: {
            current: nextProps.eventImage.event_image_types.current,
            pageSize: nextProps.eventImage.event_image_types.pageSize,
            total: nextProps.eventImage.event_image_types.totalCount
          }
        }
      } else if (nextProps.eventImage.messageId === 200) {
        notification['success']({
          message: 'Success',
          description: nextProps.eventImage.alertMessage
        });
        let pagination = state.pagination;
        state.currentInstance.fetch({ pagination });
        nextProps.resetEventImageType();
      } else if (nextProps.eventImage.messageId === 203) {
        notification['error']({
          message: 'Alert!!',
          description: nextProps.eventImage.alertMessage
        });
        nextProps.resetEventImageType();
      }
      return true;
    }
    return null;
  }

  onConfirmDelete(record) {
    this.setState({
      record: record
    }, () => {
      Modal.confirm({
        title: 'Delete',
        centered: true,
        icon: <ExclamationCircleOutlined />,
        content: 'Are you sure you want to delete ' + record.name + '?',
        okText: 'Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: this.onDeleteRecord
      });
    })
  }

  onDeleteRecord = () => {
    const { record } = this.state;
    const { authUser } = this.props.auth;
    let data = {
      _id: record._id,
      isDeleted: true
    }
    this.props.deleteEventImageType(authUser.token, data);
  }

  onConfirmRestore(record) {
    this.setState({
      record: record
    }, () => {
      Modal.confirm({
        title: 'Restore',
        centered: true,
        icon: <ExclamationCircleOutlined />,
        content: 'Are you sure you want to restore ' + record.name + '?',
        okText: 'Restore',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: this.onRestoreRecord
      });
    })
  }

  onRestoreRecord = () => {
    const { record } = this.state;
    const { authUser } = this.props.auth;
    let data = {
      _id: record._id,
      isDeleted: false
    }
    this.props.deleteEventImageType(authUser.token, data);
  }


  handleTableChange = (pagination, filters, sorter) => {
    this.fetch({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      ...filters
    });
  };

  fetch = (params = {}) => {
    let pageInfo = getRandomuserParams(params);
    const { authUser } = this.props.auth;
    if (authUser && pageInfo) {
      let inputJson = {
        current: pageInfo.pagination.current,
        pageSize: pageInfo.pagination.pageSize
      }
      if (pageInfo.isDeleted && pageInfo.isDeleted.length > 0) {
        inputJson.isDeleted = pageInfo.isDeleted[0] ? 'TRUE' : 'FALSE';
      }
      this.props.listEventImageType(authUser.token, inputJson);
    }
  }

  onSearch = value => {
    if (value) {
      const { pagination } = this.state;
      let inputJson = {
        searchString: value,
        current: 1,
        pageSize: pagination.pageSize
      }
      const { authUser } = this.props.auth;
      this.props.searchEventImageType(inputJson, authUser.token);
    }
  };

  onChange = e => {
    if (e.type === 'click') {
      const { pagination } = this.state;
      this.fetch({ pagination });
    }
  };

  render() {
    const { loader } = this.props.eventImage;
    const { pagination, eventImageTypeList } = this.state;
    return (
      <Auxiliary>
        <PageHeader title="Event Image Types" navigateTo="/event-image/add" linkName="Add Event Image Type"/>
          <>
            <Row className="row-margin2">
              <Col>
                <Search
                  placeholder="Search by Name Or Description"
                  allowClear
                  enterButton="Search"
                  size="large"
                  onSearch={this.onSearch}
                  onChange={this.onChange}
                />
              </Col>
            </Row>
            <Row className="row-margin2">
              <Col>
                <Table
                  className="gx-table-responsive"
                  columns={this.columns}
                  dataSource={eventImageTypeList}
                  rowKey={record => record._id}
                  pagination={{
                    ...pagination,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    itemRender: itemRender,
                    size: 'small'
                  }}
                  loading={loader}
                  size={'middle'}
                  onChange={this.handleTableChange}
                />
              </Col>
            </Row>
          </>
      </Auxiliary>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    eventImage: state.eventImage
  }
}

function mapDispathToProps(dispatch) {
  return bindActionCreators({ listEventImageType, deleteEventImageType, searchEventImageType, resetEventImageType }, dispatch);
}

export default connect(mapStateToProps, mapDispathToProps)(ListEventImageType);

